import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const blogService = {
  // Get all published blogs
  getAllBlogs: async () => {
    const response = await axios.get(`${API_URL}/blogs`);
    return response.data;
  },

  // Get latest 3 published blogs
  getLatestBlogs: async () => {
    const response = await axios.get(`${API_URL}/blogs/latest`);
    return response.data;
  },

  // Get a single blog by id
  getBlogById: async (id) => {
    const response = await axios.get(`${API_URL}/blogs/${id}`);
    return response.data;
  },

  // Get all blogs (including drafts) for admin
  getAllBlogsAdmin: async () => {
    const response = await axios.get(`${API_URL}/blogs/admin/all`);
    return response.data;
  },

  // Create a new blog
  createBlog: async (blogData) => {
    console.log(blogData);

    const formData = new FormData();
    Object.keys(blogData).forEach((key) => {
      if (key === 'tags') {
        formData.append(key, JSON.stringify(blogData[key]));
      } else {
        formData.append(key, blogData[key]);
      }
    });

    const response = await axios.post(`${API_URL}/blogs`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update a blog
  updateBlog: async (id, blogData) => {
    const formData = new FormData();
    Object.keys(blogData).forEach((key) => {
      if (key === 'tags') {
        formData.append(key, JSON.stringify(blogData[key]));
      } else {
        formData.append(key, blogData[key]);
      }
    });

    const response = await axios.put(`${API_URL}/blogs/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete a blog
  deleteBlog: async (id) => {
    const response = await axios.delete(`${API_URL}/blogs/${id}`);
    return response.data;
  },
};

export default blogService;
